import { render, staticRenderFns } from "./HomeItem.vue?vue&type=template&id=c4d58904&scoped=true&"
import script from "./HomeItem.vue?vue&type=script&lang=js&"
export * from "./HomeItem.vue?vue&type=script&lang=js&"
import style0 from "./HomeItem.vue?vue&type=style&index=0&id=c4d58904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d58904",
  null
  
)

export default component.exports